import React from 'react';
import Link from 'components/link/link';

type Props = {
    list?: {
        title?: string;
        url?: string;
    }[];
    color?: string;
};

function FooterFixedList(props: Props) {
    return props.list ? (
        <div className="footer-fixed__list">
            {props.list.map(({ title, url }, index) => (
                <span className="footer-fixed__item" key={`footer-fixed-item-${index}`}>
                    <Link
                        className="footer-fixed__link"
                        href={url}
                        title={title}
                        target="_blank"
                        style={{ color: props.color }}
                    >
                        {title}
                    </Link>
                </span>
            ))}
        </div>
    ) : null;
}

export default FooterFixedList;
